import {
  inboundShipmentIdFormat,
  locationIdFormat,
} from "@redotech/redo-model/ids";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";
import { InboundShipmentStatus } from "./get-shipments";

export const updateShipment = {
  name: "updateShipment" as const,
  input: z.object({
    shipmentId: inboundShipmentIdFormat.schema,
    status: z
      .enum([
        InboundShipmentStatus.PENDING,
        InboundShipmentStatus.IN_TRANSIT,
        InboundShipmentStatus.PARTIALLY_RECEIVED,
        InboundShipmentStatus.RECEIVED,
      ])
      .optional(),
    locationId: locationIdFormat.schema.optional(),
    carrier: z.string().optional(),
    estimatedArrivalDate: zExt.plainDate().nullish(),
    actualArrivalDate: zExt.plainDate().nullish(),
    freightType: z.string().nullish(),
    paymentTerms: z.string().nullish(),
    shipmentIdValue: z.string().optional(),
    trackingNumber: z.string().optional(),
    trackingUrl: z.string().optional(),
    freightCost: z.number().optional(),
    freightCurrency: z.string().optional(),
    dutyCost: z.number().optional(),
    dutyCurrency: z.string().optional(),
    customVolumeCubicMeters: z.number().nullish(),
  }),
  output: z.object({ success: z.boolean() }),
};
